export default "__VITE_ASSET__BWfkHiQf__"